import React from 'react'
import Image from 'next/image'

import { Row, Section, Column } from '@/components/layout'
import { Text } from '@/components/common'
import iconSupportImg from '@/assets/our-history/icon-support.svg'
import iconCuriosityImg from '@/assets/our-history/icon-curiosity.svg'
import iconEmpowermentImg from '@/assets/our-history/icon-empowerment.svg'
import iconJudgementImg from '@/assets/our-history/icon-judgement.svg'

const OurValues = () => (
  <Section>
    <Row>
      <Column center textCenter>
        <Text.H2>Our Values</Text.H2>
      </Column>
    </Row>

    <Row gap={32}>
      <Column center gap={8} textCenter>
        <Image alt="" src={iconSupportImg} />
        <Text.H3>Support</Text.H3>
        <Text.P>At Neat, we always start with active listening as we partner with our customers. We seek to win together. Education is in our DNA – we want to learn and we want to share our learnings to drive mutual success.</Text.P>
      </Column>

      <Column center gap={8} textCenter>
        <Image alt="" src={iconCuriosityImg} />
        <Text.H3>Curiosity</Text.H3>
        <Text.P>Innovation is only possible when we thirst for knowledge. Curiosity drives all of us at Neat to challenge ourselves and our assumptions in order to create a better product and experience for our customers.</Text.P>
      </Column>
    </Row>

    <Row gap={32}>
      <Column center gap={8} textCenter>
        <Image alt="" src={iconEmpowermentImg} />
        <Text.H3>Empowerment</Text.H3>
        <Text.P>We create tools to empower our customers to do it themselves, whenever and wherever. We trust our teammates and our partners and provide what’s needed to make everyone work smarter. Empowerment starts with support and thrives with curiosity.</Text.P>
      </Column>

      <Column center gap={8} textCenter>
        <Image alt="" src={iconJudgementImg} />
        <Text.H3>Sound Judgment</Text.H3>
        <Text.P>We identify root causes and generate ideas to go beyond just treating symptoms, even when ambiguity is present. We make decisions and hold ourselves accountable for delivering on our promises.</Text.P>
      </Column>
    </Row>
  </Section>
)

export default OurValues
